import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared form submission state: idle | loading | success | error
export const useFormSubmit = (endpoint, onSuccess) => {
  const [status, setStatus] = useState("idle");
  const submit = async (payload) => {
    setStatus("loading");
    try {
      const res = await axios.post(`${API}/${endpoint}`, payload);
      onSuccess?.(res.data);
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };
  return { status, submit, reset: () => setStatus("idle") };
};

export const inputCls = "bg-white border-hacienda-border-light focus-visible:ring-hacienda-terracotta h-11";
export const selectCls = `w-full rounded-md border px-3 text-sm text-hacienda-charcoal ${inputCls}`;
export const submitBtnCls = "rounded-full bg-hacienda-terracotta hover:bg-hacienda-terracotta-dark disabled:opacity-60 disabled:cursor-not-allowed text-white font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hacienda-terracotta";
